import { mapGetters, mapActions } from 'vuex';

export const cruiseTypesOptionsMixin = {
    data() {
        return {
            isCruiseTypesLoading: false,
        };
    },
    computed: {
        ...mapGetters({ getCruiseTypes: 'options/getCruiseTypes' }),
    },
    methods: {
        ...mapActions({ dispatchCruiseTypes: 'options/dispatchCruiseTypes' }),
        async fetchCruiseTypes() {
            this.isCruiseTypesLoading = true;

            try {
                const { data } = await this.axios.get('/cruise-types');
                if (data.data?.length) this.dispatchCruiseTypes(data.data);
            } catch (ex) {
                console.log('cant fetch cruise types: ' + ex);
            }

            this.isCruiseTypesLoading = false;
        },
    },
};
